/**
 * Created by Astha on 7/12/2019.
 */
import React from "react";
import Form from "../common/form/Form";
const debug = require('../debug/debug')('wc:ai:renderAiForm');

export default function renderAiForm(data: HashMap | Object[],
                                     className: string = "",) {
  const fields = [
    {
      disabled: true,
      hideLabel: true,
      invalid: false,
      key: "key",
      label: "key",
      type: "TextBox",
      value: "IPTC_Creator: Address",
      __data: "IPTC_Creator: Address"
    },
    {
      disabled: false,
      hideLabel: false,
      invalid: false,
      key: "startTimeMs",
      label: "Time In",
      type: "TextBox",
      value: "00:01:15",
      __data: "00:01:15"
    },
    {
      disabled: false,
      hideLabel: false,
      invalid: false,
      key: "stopTimeMs",
      label: "Time Out",
      type: "TextBox",
      value: "00:02:15",
      __data: "00:02:15"
    },{
      disabled: false,
      hideLabel: false,
      invalid: false,
      key: "value",
      label: "Value",
      type: "TextBox",
      value: "dsdsd",
      __data: "dsdsd"
    }


  ];
  return (
    <Form
      fields={fields}
    />
  )
}

